var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendarPropIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 2.5999H13.4C13.5591 2.5999 13.7117 2.66312 13.8243 2.77564C13.9368 2.88816 14 3.04077 14 3.1999V12.7999C14 12.959 13.9368 13.1116 13.8243 13.2242C13.7117 13.3367 13.5591 13.3999 13.4 13.3999H2.6C2.44087 13.3999 2.28826 13.3367 2.17574 13.2242C2.06321 13.1116 2 12.959 2 12.7999V3.1999C2 3.04077 2.06321 2.88816 2.17574 2.77564C2.28826 2.66312 2.44087 2.5999 2.6 2.5999H5V1.3999H6.2V2.5999H9.8V1.3999H11V2.5999ZM9.8 3.7999H6.2V4.9999H5V3.7999H3.2V6.1999H12.8V3.7999H11V4.9999H9.8V3.7999ZM12.8 7.3999H3.2V12.1999H12.8V7.3999Z",
    fill: "#A4A4A4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarPropIcon);
export default __webpack_public_path__ + "static/media/calendar_prop_icon.fb0f0bb761b69b1b623c9cec7e3c14d6.svg";
export { ForwardRef as ReactComponent };